import React from 'react';
import styled from 'styled-components';
import Img from '../components/Img';
import {Container} from '../styles/Grids';
import {breakPoint} from '../styles/var';
// images
import img_bg from '../assets/img/PC3-1.png';
import img_title from '../assets/img/PC3-2.png';
import img_btn from '../assets/img/PC3-3.png';
import {NoStyleButton} from '../components/Button';

const ContentStyles = styled.div`
  color: var(--white);
  background: var(--bg) url(${img_bg}) no-repeat center center / cover;
  box-shadow: 0 6px 10px rgba(0,0,0, .3);
  .container {
    padding: 2.5rem 2rem;
  }
  .title, .btn {
    margin-right: auto;
    margin-left: auto;
  }
  .title {
    max-width: 30rem;
  }
  .btn {
    max-width: 10rem;
  }
  .content {
    font-size: 2.1rem;
    letter-spacing: 1px;
  }
  @media (min-width: ${breakPoint.min}) {
    .container {
      padding-top: 5rem;
      padding-bottom: 5rem;
    }
    .title {
      max-width: 48rem;
    }
    .btn {
      max-width: 18rem;
    }
    .content {
      font-size: 2.8rem;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    .title {
      max-width: 26rem;
    }
    .content {
      font-size: 1.8rem;
    }
    .btn {
      max-width: 9rem;
    }
  }
`;

const Section3 = (props) => {
  return (
    <ContentStyles {...props}>
      <Container className="container center">
        <Img src={img_title} auto wrapProps={{className: 'title'}}/>
        <div className="content">
          <p>秀出你的風格家庭短片 得大獎<br />
            徵件&投票活動辦法</p>
        </div>
        <NoStyleButton href="https://bit.ly/3yHKEVZ">
          <Img src={img_btn} auto wrapProps={{className: 'btn'}}/>
        </NoStyleButton>
      </Container>
    </ContentStyles>
  )
};

export default Section3;
